import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { AngularFireAuth } from "@angular/fire/auth";
import { MatDialog } from '@angular/material/dialog';
import { Loja } from 'src/app/interfaces/manutencao.sistema';

@Component({
    selector: 'app-manutencao-loja',
    templateUrl: './manutencao-loja.component.html',
    styleUrls: ['./manutencao-loja.component.scss', '../../styles/estilo.padrao.scss']
})
export class ManutencaoLojaComponent implements OnInit {
    uid;
    manutencaoForm: FormGroup;
    picker: any;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private toastr: ToastrService,
        private usuarioService: UsuarioService,
        private spinner: NgxSpinnerService,
        private af: AngularFireAuth,
        private dialog: MatDialog,
    ) {
        this.uid = localStorage.getItem('uid');

        //Validar Permissões
        this.af.authState.subscribe(snap => {
            this.uid = snap.uid;
        });
    }

    //Máscaras
    maskDate = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, ":", /\d/, /\d/];

    ngOnInit(): void {
        this.spinner.show('default');

        this.manutencaoForm = this.formBuilder.group({
            descricao: ['', [Validators.required, Validators.minLength(10)]],
            status: [true],
            previsaoRetorno: ['', [Validators.required]],
        });

        this.usuarioService.getSistema().pipe(take(1)).subscribe(snap => {
            if (snap) {
                const dados: Loja = snap.payload.val() as Loja;
                this.manutencaoForm.patchValue({
                    descricao: dados.Descricao,
                    status: dados.Status,
                    previsaoRetorno: dados.PrevisaoRetorno
                });
            }

            this.spinner.hide('default');
        });
    }

    atualizar() {
        this.spinner.show('default');
        console.log(this.manutencaoForm);

        if (this.manutencaoForm.valid) {
            let data = this.f.previsaoRetorno.value.replaceAll('/', '-');
            data = `${data.substring(6, 10)}-${data.substring(3, 5)}-${data.substring(0, 2)} ${data.substring(11, 19)}`;

            console.log(data)
            console.log(new Date(data).getTime())

            if (new Date(data).getTime() <= new Date().getTime()) {
                console.log('FALHA')
                this.toastr.error('Informe uma previsão de retorno válida', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
                this.spinner.hide('default');
                return;
            }

            const map: Loja = {
                Descricao: this.f.descricao.value,
                Status: this.f.status.value,
                PrevisaoRetorno: this.f.previsaoRetorno.value,
            }

            this.usuarioService.updateSistema(map).then(resp => {
                if (resp.Status) {
                    this.toastr.success(resp.Mensagem, 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                    setTimeout(() => {
                        this.spinner.hide('default');

                        this.usuarioService.setLog("Alteração de sistema.", map, this.uid);

                        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                            this.router.navigate(["/pages/manutencao-loja"]));
                    }, 1500);
                }
            });

        } else {
            this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
            this.manutencaoForm.markAllAsTouched();
            setTimeout(() => this.spinner.hide('default'), 500);
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.manutencaoForm.controls; }

}
